import { render } from "./GroupOverviewTab.vue?vue&type=template&id=0180ec4a&scoped=true"
import script from "./GroupOverviewTab.vue?vue&type=script&lang=js"
export * from "./GroupOverviewTab.vue?vue&type=script&lang=js"

import "./GroupOverviewTab.vue?vue&type=style&index=0&id=0180ec4a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0180ec4a"]])

export default __exports__